export default __webpack_public_path__ + "5c4afba0d55ac9b9bdc1f15f857134db.png";